import React, { useState } from "react";
import Productivity from "./Productivity";
import Header from "../common/Header";
import { QuickActionBtnIcon } from "../common/Icon";
import QuickActions from "../quick-action-popup/QuickActions";
import { useStateProvider } from "../common/StateProvider";

const Dashboard = () => {
  // QUICK ACTIONS MODAL
  const {
    quickActionModal,
    setQuickActionModal,
    setLogChatNotesModal,
    setLogChatModal,
    setProfileCalendar,
  } = useStateProvider();
  const closeQuickActionModal = () => {
    setLogChatNotesModal(false);
    setLogChatModal(false);
    setProfileCalendar(false);
    setQuickActionModal(false);
  };
  const toggleQuickActionModal = () => {
    setLogChatNotesModal(false);
    setLogChatModal(false);
    setProfileCalendar(false);
    setQuickActionModal(!quickActionModal);
  };
  return (
    <>
      <div className="bg-light_purple7 rounded-2xl overflow-x-hidden  h-[calc(100vh-32px)] ">
        <div className=" relative overflow-hidden">
          <div className=" overflow-hidden  px-5">
            <Header text="Dashboard" />
          </div>
          <Productivity />
        </div>
        <div className="relative">
          <div className="fixed right-0 bottom-7 2xl:bottom-7 3xl:bottom-10 z-[28]">
            <div className=" relative">
              <button
                onClick={toggleQuickActionModal}
                className=" relative rounded-[8px_0px_0px_8px] bg-primary shadow-[0px_1px_14px_0px_rgba(111,_106,_248,_0.19)] p-2 md:px-[18px] md:py-2.5 flex items-center gap-[14px]">
                <span className="bg-white rounded-[5.455px] p-1">
                  <QuickActionBtnIcon />
                </span>
                <span className="text-[14px] font-bold text-white hidden md:block">
                  Quick Actions
                </span>
              </button>
              <div className="absolute top-[-190px]  right-[20px]  xl:top-[-200px] z-[99999]">
                {quickActionModal && <QuickActions />}
              </div>
            </div>
          </div>
        </div>
        <div
          onClick={closeQuickActionModal}
          className={`fixed inset-0 min-h-full w-full z-20  bg-black opacity-10 ${
            quickActionModal ? "w-[100%] " : "hidden"
          }`}></div>
      </div>
    </>
  );
};

export default Dashboard;
